import config from './WebIMConfig'
import websdk from 'easemob-websdk'
import emedia from 'easemob-emedia'
import webrtc from 'easemob-webrtc'
import store from '@/store'
import { stuSortUserOrGroup } from '@/utils/groupChat'
import { hrReplyMsgNotice, singleCase, updateMsgReadStatus } from '@/utils/tool'
import concatChat from '@/utils/concatChat'

// 表示消息回执 将消息 修改为已读状态
function ack(message) {
  /* 将整个会话重置为已读 */
  if ( !Reflect.has(message, 'from') || !Reflect.has(message, 'type') ) return
  updateMsgReadStatus(message.from, message.type === 'chat' ? 'contact' : 'groupChat')
}

// 初始化IM SDK
var WebIM = {}
WebIM = window.WebIM = websdk
WebIM.config = config
WebIM.conn = new WebIM.connection({
  appKey: WebIM.config.appkey,
  isHttpDNS: WebIM.config.isHttpDNS,
  isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
  https: WebIM.config.https,
  url: WebIM.config.xmppURL,
  apiUrl: WebIM.config.apiURL,
  isAutoLogin: true,
  heartBeatWait: WebIM.config.heartBeatWait,
  autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
  autoReconnectInterval: WebIM.config.autoReconnectInterval,
  isStropheLog: WebIM.config.isStropheLog,
  delivery: WebIM.config.delivery
})
if ( !WebIM.conn.apiUrl ) {
  WebIM.conn.apiUrl = WebIM.config.apiURL
}

// 注册监听回调
WebIM.conn.listen({
  /* 企业端环信连接 */
  onOpened: function() {
    console.log('用户端环信连接成功')
    sessionStorage.removeItem('hx_loading')
    if ( singleCase.__loginInitLoading__ ) {
      concatChat._queryAllMsgUser({}, false)
      Reflect.deleteProperty(singleCase, '__loginInitLoading__')

      /* 延迟推送 */
      let timer = setTimeout(() => {
        Reflect.deleteProperty(singleCase, '__pushTimeout__')
        clearTimeout(timer)
        timer = null
      }, 4000)
    }
  },
  onClosed: function() {
    console.log('用户端环信断开连接')
  },

  /* 接受消息 */
  onTextMessage: function(message) {

    /* 如果变量存在 表示不进行推送 */
    if ( singleCase.__pushTimeout__ ) return

    console.log(message)

    const { from, to, type, data } = message
    // 表示添加用户
    const chatId = type !== 'chat' ? to : from
    // 解构消息 类型 时间戳
    const [ messages, langType, time, otherArr = null ] = data.split('@@@')

    /* 如果langType是104 表示hr回复了消息 messages 群id otherArr 群名称 */
    if ( langType === '104' ) hrReplyMsgNotice(messages, otherArr)

    if ( langType == '100' ) {
      store.dispatch('updateJob', { name: from, positionId: messages, isSelf: false })
    }
    if ( message.ext.confrId && message.ext.password ) {
      store.commit('noticeCall', message)
    }

    /* 如果消息类型是120 代表是引用 需要做特殊处理 */
    let [ selfMsg, quoteMsg, quoteMid ] = []
    if ( langType === '120' ) {
      [ selfMsg, quoteMsg, quoteMid ] = messages.split('###')
    }

    /* 进行排序 */
    stuSortUserOrGroup(type, chatId)
    store.commit('updateMsgList', {
      chatType: type === 'chat' ? 'contact' : 'group',
      chatId: chatId,
      msg: selfMsg ? selfMsg : messages,
      quoteMsg,
      quoteMid,
      langType,
      otherArr, // 附加的信息字段
      time,
      to,
      bySelf: false,
      from: message.from,
      mid: message.id
    })
    let currentId = localStorage.getItem('currentId')
    type === 'chat' && currentId == message.from && ack(message)
  },

  /* 接受表情 */
  onEmojiMessage: function(message) {
    console.log(message)
    const { type, from, to } = message
    const chatId = type !== 'chat' ? to : from
    /* 进行排序 */
    stuSortUserOrGroup(type, chatId)
    let currentId = localStorage.getItem('currentId')
    type === 'chat' && currentId == message.from && ack(message)
  },

  onPictureMessage: function(message) {
    const { from, to, type } = message
    const chatId = type !== 'chat' ? to : from
    /* 进行排序 */
    stuSortUserOrGroup(type, from)
    store.commit('updateMsgList', {
      chatType: 'contact',
      chatId: chatId,
      msg: message.url,
      mid: message.id,
      bySelf: false,
      type: 'img',
      to,
      langType: '2',
      time: message.ext.time || + new Date(),
      from: message.from
    })
    let currentId = localStorage.getItem('currentId')
    type === 'chat' && currentId == message.from && ack(message)
  }, // 收到图片消息
  onCmdMessage: function(message) {
    /* 进行排序 */
    stuSortUserOrGroup(message['type'], message['from'])
    let currentId = localStorage.getItem('currentId')
    type === 'chat' && currentId == message.from && ack(message)
  },

  // 接受语音消息
  onAudioMessage: function(message) {
    /* 进行排序 */
    stuSortUserOrGroup(message['type'], message['from'])
    const typeMap = {
      chat: 'contact',
      groupchat: 'group',
      chatroom: 'chatroom'
    }
    const chatId = message.type !== 'chat' ? message.to : message.from
    let options = {
      url: message.url,
      headers: { Accept: 'audio/mp3' },
      onFileDownloadComplete: function(response) {
        let objectUrl = ''
        store.commit('updateMsgList', {
          chatType: typeMap[message.type],
          chatId: chatId,
          msg: objectUrl,
          bySelf: false,
          langType: '3',
          type: 'audio',
          from: message.from
        })
      },
      onFileDownloadError: function() {
        console.log('音频下载失败')
      }
    }

    let currentId = localStorage.getItem('currentId')
    type === 'chat' && currentId == message.from && ack(message)

  }, // 收到音频消息
  onLocationMessage: function(message) {
    /* 进行排序 */
    stuSortUserOrGroup(message['type'], message['from'])
    let currentId = localStorage.getItem('currentId')
    type === 'chat' && currentId == message.from && ack(message)
  },
  onFileMessage: function(message) {
    const { from, to, type } = message
    const chatId = type !== 'chat' ? to : from
    /* 进行排序 */
    stuSortUserOrGroup(message['type'], message['from'])
    store.commit('updateMsgList', {
      chatType: 'contact',
      chatId: chatId,
      msg: message.url,
      bySelf: false,
      mid: message.id,
      type: 'file',
      langType: '5',
      filename: message.filename,
      file_length: message.file_length,
      from: message.from
    })
    let currentId = localStorage.getItem('currentId')
    type === 'chat' && currentId == message.from && ack(message)
  }, // 收到文件消息
  onVideoMessage: function(message) {
    console.log('有视频了')
    const { from, to, type } = message
    const chatId = type !== 'chat' ? to : from
    /* 进行排序 */
    stuSortUserOrGroup(type, from)
    const typeMap = {
      chat: 'contact',
      groupchat: 'group',
      chatroom: 'chatroom'
    }
    let options = {
      url: message.url,
      headers: {
        Accept: 'audio/mp4'
      },
      onFileDownloadComplete: function(response) {
        let objectURL = ''
        store.commit('updateMsgList', {
          chatType: typeMap[message.type],
          chatId: chatId,
          msg: objectURL,
          bySelf: false,
          type: 'video',
          filename: message.filename,
          file_length: message.file_length,
          from: message.from
        })
      },
      onFileDownloadError: function() {
        console.log('视频下载失败')
      }
    }
  },

  /* 进行事件订阅 例如：退群等 */
  onPresence: function(message) {
    switch ( message.type ) {
      case 'subscribe':
        let options = {
          isShow: true,
          ...message
        }
        store.commit('changeFriendRequestState', options)
        break
      case 'subscribed':
        store.dispatch('onGetContactUserList')
        break
      case 'unsubscribed':
        store.dispatch('onGetContactUserList')
        // TODO
        if ( 'code' in message ) {
          alert(message.from + ' ' + '请求被拒绝')
        } else {
        }
        break

      case 'direct_joined': // 被拉进群--不需要同意
        // store.dispatch("onGetGroupUserList")
        break
      case 'invite': // 收到邀请进群的通知
        let groupInviteOptions = {
          isShow: true,
          ...message
        }
        store.commit('updateGroupInviteNotifications', groupInviteOptions)
        break
      case 'joinGroupNotifications': // 收到申请进群的通知
        let groupOptions = {
          isShow: true,
          ...message
        }
        store.commit('updateGroupNotifications', groupOptions)
        break

      /* 邀请同时加入群聊 */
      case 'memberJoinPublicGroupSuccess':
        store.dispatch('currentGAllUserStu', { userId: message.from, groupId: message.gid })
        break
      case 'joinPublicGroupSuccess': // 申请加入群组成功回调
        // store.dispatch("onGetGroupUserList");
        break

      // 解散群组
      case 'deleteGroupChat':
        store.dispatch('removeCGroupUserStu', { groupId: message.gid })
        break
      // 移除
      case 'removedFromGroup':
        store.dispatch('removeCGroupUserStu', { groupId: message.gid })
        break
      // 一般都是其余的人 离开群组
      case 'leaveGroup':
        store.dispatch('delCGroupOtherUser', { groupId: message.gid, userId: message.from })
        break
      default:
        break
    }
  },
  onRoster: function(message) {
    console.log('onRoster', message)
  }, // 处理好友申请
  onInviteMessage: function(message) {
    console.log('onInviteMessage', message)
  }, // 处理群组邀请
  onOnline: function() {
    console.log('onOnline 网络已连接')
  }, // 本机网络连接成功
  onOffline: function() {
    console.log('onOffline 网络已断开')
  }, // 本机网络掉线
  onError: function(message) {
    console.log(message)
  }, // 失败回调
  onRecallMessage: message => {
    message.status = 'recall'
    message.msg = '对方撤回了一条消息'
    message.isRecall = true
    message.langType = '12'
    store.commit('updateMessageStatus', message)
  },
  onBlacklistUpdate: function() { // 黑名单变动

  },
  onReceivedMessage: function() {

  }, // 收到消息送达服务器回执

  onDeliveredMessage: function() {

  }, // 收到消息送达客户端回执

  onReadMessage: function() {

  }, // 收到消息已读回执

  onCreateGroup: function() {

  },
  onMutedMessage: function() {

  },

  /* 设置整体会话已读 消息回执 */
  onChannelMessage: function(message) {
    // console.log('onChannelMessage')
    store.commit('updateMessageStatus', { action: 'oneUserReadMsgs', name: 'contact', readUser: message.from })
  }
})

WebIM.WebRTC = webrtc
WebIM.EMedia = emedia
export default WebIM



// WEBPACK FOOTER //
// ./src/utils/WebIM.js